import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { useCustomSnackbar } from '../hooks/useCustomSneakbar';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const CompetitiveExamTopicMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const initialFormState = {
        competitiveExamNameMasterId: '',
        competitiveExamBookMasterId: '',
        subjectMasterId: '',
        competitiveLessonMasterId: '',
        competitiveTopicNames: ['']
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [topicData, setTopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [bookList, setBookList] = useState([])
    const [subjectList, setSubjectList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [examNameSort, setExamNameSort] = useState(null);
    const [bookNameSort, setBookNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["competitiveExamNameMasterDetails.examName", "competitiveExamBookMasterDetails.bookName", "subjectMasterDetails.subjectName", "competitiveLessonMasterDetails.competitiveLessonName", "competitiveTopicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getTopicList();
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (topicData.competitiveExamNameMasterId !== '' && topicData.competitiveExamBookMasterId !== '' && topicData.subjectMasterId !== '') {
                let apiUrl = '/get-competitive-topic?';

                if (topicData.competitiveExamBookMasterId) {
                    apiUrl += `competitiveExamBookMasterId=${topicData.competitiveExamBookMasterId}&`;
                }

                if (topicData.subjectMasterId) {
                    apiUrl += `subjectMasterId=${topicData.subjectMasterId}&`;
                }

                if (topicData.competitiveLessonMasterId) {
                    apiUrl += `competitiveLessonMasterId=${topicData.competitiveLessonMasterId}&`;
                }

                apiUrl = apiUrl.replace(/&$/, '');
                setTopicList(await searchArray("A", apiUrl, searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (topicData.competitiveExamNameMasterId !== '' && topicData.competitiveExamBookMasterId !== '' && topicData.subjectMasterId !== '') {
            // Construct the API URL when syllabusData changes
            let apiUrl = '/get-competitive-topic?';

            if (topicData.competitiveExamBookMasterId) {
                apiUrl += `competitiveExamBookMasterId=${topicData.competitiveExamBookMasterId}&`;
            }

            if (topicData.subjectMasterId) {
                apiUrl += `subjectMasterId=${topicData.subjectMasterId}&`;
            }

            if (topicData.competitiveLessonMasterId) {
                apiUrl += `competitiveLessonMasterId=${topicData.competitiveLessonMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            // Make the API call
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result);
                })
                .catch(error => {
                    setTopicList(error?.response?.data.result);
                    console.error('Error fetching data:', error);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    // Swal.fire(
                    //     { text: errorMsg }
                    // );

                });
        }
    }, [topicData, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(topicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(topicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > topicList.length) {
            endIndex = topicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(topicList.slice(startIndex, endIndex));
    }, [topicList, currPage, itemsPerPage]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-competitive-exam-names`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }

    const getTopicList = () => {
        if (topicData.competitiveExamNameMasterId !== '' && topicData.competitiveExamBookMasterId !== '' && topicData.subjectMasterId !== '') {
            // Construct the API URL when syllabusData changes
            let apiUrl = '/get-competitive-topic?';

            if (topicData.competitiveExamBookMasterId) {
                apiUrl += `competitiveExamBookMasterId=${topicData.competitiveExamBookMasterId}&`;
            }

            if (topicData.subjectMasterId) {
                apiUrl += `subjectMasterId=${topicData.subjectMasterId}&`;
            }

            if (topicData.competitiveLessonMasterId) {
                apiUrl += `competitiveLessonMasterId=${topicData.competitiveLessonMasterId}&`;
            }
            // const apiUrl = `/get-topic-master-list`;
            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result)
                    setAddNew(!addNew)
                })
                .catch(error => {
                    // Handle any errors that occurred during the request
                    console.error('Error fetching data:', error);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                });
        }
    }

    const handleInputChange = (e, index) => {
        setTopicData((prevData) => {
            if (e.target.name === 'competitiveTopicNames') {
                // Update the value at the specified index
                const updatedTopicName = [...prevData.competitiveTopicNames];
                updatedTopicName[index] = e.target.value;
                return {
                    ...prevData,
                    competitiveTopicNames: updatedTopicName,
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    const handleAddTopic = () => {
        setTopicData((prevData) => ({
            ...prevData,
            competitiveTopicNames: [...prevData.competitiveTopicNames, ''],
        }));
    };

    const handleRemoveTopic = (index) => {
        setTopicData((prevData) => {
            const updatedTopicName = [...prevData.competitiveTopicNames];
            // Remove the element at the specified index
            updatedTopicName.splice(index, 1);
            return {
                ...prevData,
                competitiveTopicNames: updatedTopicName,
            }
        });
    }

    const handleSyllabusChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: '',
                competitiveExamBookMasterId: '',
                competitiveLessonMasterId: ''
            }
        })


        const apiUrl2 = `/get-competitive-exam-book-master?competitiveExamNameMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setBookList(response.data.data)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });

    }

    const handleBookChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: '',
                competitiveLessonMasterId: '',
            }
        })

        const apiUrl2 = `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            });
    }


    const handleSubjectChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
            }
        })

        const apiUrl = `/get-competitive-lesson?competitiveExamBookMasterId=${topicData.competitiveExamBookMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                console.log("lesson", response.data);
                setLessonList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                setLessonList(error?.response?.data.result);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

    }

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(topicData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(topicData)) {
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [topicData])

    const addTopic = () => {
        const apiUrl = `/add-competitive-topic`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, topicData)
                .then(response => {
                    getTopicList();
                    setTopicData((prevData) => {
                        return {
                            ...prevData,
                            competitiveTopicNames: [''],
                        }
                    })

                    setSaveId(response.data.result[0].id);
                    setExamNameSort(null);
                    setBookNameSort(null);
                    setSubjectNameSort(null);
                    setLessonNameSort(null);
                    setTopicNameSort(null);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(topicData)) {
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteTopic = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-competitive-topic?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, topicList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateTopic = () => {
        setLoading(true);
        const apiUrl = `/edit-competitive-topic?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, { competitiveTopicName: topicData?.competitiveTopicNames[0] })
            .then(response => {
                getTopicList();
                setSaveId(response.data.result.id);
                setEditId(null);
                setTopicData((prevData) => {
                    return {
                        ...prevData,
                        competitiveTopicNames: [''],
                    }

                })

                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setBookNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (bookNameSort == true || bookNameSort == false) {
            setExamNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [bookNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [subjectNameSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setSubjectNameSort(null);
            setTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
        }
    }, [topicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Topic  Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-hashtag"></i> Competitive Exam Topic Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='competitiveExamNameMasterId' onChange={handleSyllabusChange} value={topicData.competitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam Structure</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.examName}</option>
                                                            })
                                                        }
                                                    </select>

                                                    {error.competitiveExamNameMasterId && <p style={{ color: 'red' }}>{error.competitiveExamNameMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select class="form-select" aria-label="Default select example" name='competitiveExamBookMasterId' onChange={handleBookChange} value={topicData.competitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveExamBookMasterId && <p style={{ color: 'red' }}>{error.competitiveExamBookMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={topicData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select class="form-select" aria-label="Default select example" name='competitiveLessonMasterId' onChange={handleInputChange} value={topicData.competitiveLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.competitiveLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveLessonMasterId && <p style={{ color: 'red' }}>{error.competitiveLessonMasterId}</p>}
                                                </div>

                                            </div>
                                            <div className="row">
                                                {topicData.competitiveTopicNames.map((topic, index) => (
                                                    <>
                                                        <div className="col-md-11">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Topic Name :</label>
                                                            <input type="text" className="form-control" id={`competitiveTopicNames${index}`} name='competitiveTopicNames' onChange={(e) => handleInputChange(e, index)} value={topic} />
                                                            {error.competitiveTopicNames && <p style={{ color: 'red' }}>{error.competitiveTopicNames}</p>}

                                                        </div>
                                                        {topicData.competitiveTopicNames.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveTopic(index)} ><i className="material-icons" style={{ fontSize: '20px' }}>delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ width: '220px' }} onClick={handleAddTopic}>+ Add Another Topic Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTopic}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setTopicList([]); setEditId(''); setTopicData(initialFormState) }}>Reset</button>

                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateTopic} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope='col'>
                                                                            Exam Name
                                                                            <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterDetails.examName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Name
                                                                            <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"competitiveExamBookMasterDetails.bookName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"competitiveLessonMasterDetails.competitiveLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"competitiveTopicName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((topic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{topic?.competitiveExamNameMasterDetails?.examName}</td>
                                                                                        <td>{topic?.competitiveExamBookMasterDetails?.bookName}</td>
                                                                                        <td>{topic?.subjectMasterDetails?.subjectName}</td>
                                                                                        <td>{topic?.competitiveLessonMasterDetails?.competitiveLessonName}</td>
                                                                                        <td>{topic?.competitiveTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setTopicData({
                                                                                                    competitiveExamNameMasterId: topic.competitiveExamNameMasterId,
                                                                                                    competitiveExamBookMasterId: topic.competitiveExamBookMasterId,
                                                                                                    subjectMasterId: topic.subjectMasterId,
                                                                                                    competitiveLessonMasterId: topic.competitiveLessonMasterId,
                                                                                                    competitiveTopicNames: [topic.competitiveTopicName]
                                                                                                });
                                                                                                setEditId(topic.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === topic.id} onClick={() => deleteTopic(topic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Competitive Exam Topic Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={topicList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default CompetitiveExamTopicMaster;